// REACT & REACT HOOKS
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

// STORE ACTIONS
import { addEmployee, getAllRoles } from "store/actions";

// COMPONENTS
import Loader from "components/shared/loader";
import SaveChangesButton from "components/Form/save-changes-button";
import FormWrapper from "components/Form/form-wrapper";
import Form from "components/Form";
import Input from "components/Form/input";

// HELPERS
import { getId, handleErrMsg } from "helpers/functions";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const AddEmployee = () => {
    const { formatMessage, locale } = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, error } = useSelector((state) => state.employees);
    const { loading: dataLoading, roles } = useSelector((state) => state.data);
    useEffect(() => {
        dispatch(getAllRoles());
    }, []);
    // error
    useEffect(() => {
        if (Object.keys(error)?.length > 0) {
            toastErrorMessage(
                formatMessage({ id: handleErrMsg(error) }),
                locale
            );
        }
    }, [error, formatMessage, locale, navigate]);

    const onSubmitDetails = (data) => {
        dispatch(addEmployee({ data, navigate }));
    };

    const renderRoles = roles?.length > 0 && (
        <>
            <h5>
                <FormattedMessage id="employee-role" />
            </h5>
            {roles.map((role, index) => (
                <Input
                    key={index}
                    name="role"
                    type="radio"
                    value={getId(role)}
                    langId={false}
                    lg="4"
                    breakpoints={{ md: 3 }}
                >
                    <small className="ps-2">
                        <FormattedMessage id={role?.name} />
                    </small>
                </Input>
            ))}
        </>
    );

    if (loading || dataLoading) return <Loader />;
    return (
        <FormWrapper title={"addEmployee"} lg={12}>
            <Form onSubmit={onSubmitDetails}>
                <Input name="firstName" />
                <Input name="lastName" />
                <Input type="email" name="email" />

                {renderRoles}

                <h5 className="main-colored">
                    <FormattedMessage id="invitation-link" />
                </h5>
                <Input
                    name="invitationLinkType"
                    type="radio"
                    value="email"
                    langId={false}
                    lg="4"
                >
                    <small>
                        <FormattedMessage id="sendToMail" />
                    </small>
                </Input>
                <Input
                    name="invitationLinkType"
                    type="radio"
                    value="link"
                    langId={false}
                    lg="4"
                >
                    <small>
                        <FormattedMessage id="getUrl" />
                    </small>
                </Input>
                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
};

export default AddEmployee;
